import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import classes from "./index.module.css";
import ManufacturerGroupReportFilter from "./ManufacturerGroupReportFilter";
import ManufacturerGroupReportSummary from "./ManufacturerGroupReportSummary";
import AddManufacturerGroup from "./addManufacturerGroup/index";

const ManufacturerGroup = () => {
  const [showAddManufacturerGroup, setShowAddManufacturerGroup] =
    useState(false);
  const [manufacturerGroupData, setManufacturerGroupData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();

  const addManufacturerGroup = useCallback((isEdit = false) => {
    if (isEdit) {
      const data = reportRef.current.getCurrentRowData();
      setManufacturerGroupData(data);
    }
    setShowAddManufacturerGroup(true);
  }, []);

  const closeManufacturerGroupAc = useCallback(() => {
    setShowAddManufacturerGroup(false);
    setManufacturerGroupData(null);
    setCurrentComponent("grid_reports");
  }, [setCurrentComponent]);

  const debounceCloseManufacturerGroupAc = _.debounce(
    closeManufacturerGroupAc,
    200
  );

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        setRefreshData(true);
        return;
      }
      if (ctrlKey && key === "e") {
        if (currentRowData) return editRef.current.click();
      }
      if (altKey && key === "g") {
        return addManufacturerGroup();
      }
    },
    [addManufacturerGroup, currentRowData]
  );

  const applyFilterHandler = useCallback((params, filterStates) => {
    setRefreshData(false);
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addManufacturerGroup(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addManufacturerGroup, currentRowData]);
  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);
    }
  }, [refreshData]);
  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddManufacturerGroup &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [
    currentComponent,
    listener,
    onColumnShow,
    onFilterShow,
    showAddManufacturerGroup,
  ]);
  return (
    <div className={classes["manufacturer-grp-report-container"]}>
      <Reports
        identifier="manufacturerGroup"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        filterStates={filterStates}
        filterParams={filterParams}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        filters={
          <ManufacturerGroupReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            refreshData={refreshData}
            onFilterShow={onFilterShow}
            applyFilters={applyFilterHandler}
          />
        }
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
      />
      <ManufacturerGroupReportSummary
        refreshData={() => {
          setRefreshData(true);
        }}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addManufacturerGroup();
        }}
      />
      <Autocomplete
        show={showAddManufacturerGroup}
        height="50%"
        width="50%"
        closeAutoComplete={debounceCloseManufacturerGroupAc}
      >
        <AddManufacturerGroup
          manufacturerData={manufacturerGroupData}
          onEscape={debounceCloseManufacturerGroupAc}
          onSaveManufacturer={() => {
            debounceCloseManufacturerGroupAc();
            setRefreshData(true);
          }}
        />
      </Autocomplete>
    </div>
  );
};

export default ManufacturerGroup;
